'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBlurLinear = function MdBlurLinear(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 28.4c-0.9 0-1.6-0.8-1.6-1.8s0.7-1.6 1.6-1.6 1.8 0.7 1.8 1.6-0.8 1.8-1.8 1.8z m0-6.8c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.8 0.7 1.8 1.6-0.8 1.6-1.8 1.6z m0-6.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.8 1.6-1.8 1.8 0.8 1.8 1.8-0.8 1.6-1.8 1.6z m6.8 5.9c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.9 0.9-0.9 0.7 0.4 0.7 0.9-0.3 0.9-0.7 0.9z m0-6.8c-0.5 0-0.9-0.3-0.9-0.7s0.4-0.9 0.9-0.9 0.7 0.4 0.7 0.9-0.3 0.7-0.7 0.7z m-23.4-9.1h30v3.4h-30v-3.4z m23.4 22.5c-0.5 0-0.9-0.4-0.9-0.9s0.4-0.7 0.9-0.7 0.7 0.3 0.7 0.7-0.3 0.9-0.7 0.9z m-13.4 0.9c-0.9 0-1.6-0.8-1.6-1.8s0.7-1.6 1.6-1.6 1.6 0.7 1.6 1.6-0.7 1.8-1.6 1.8z m-6.6-5.9c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m0-6.6c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z m-3.4 19.1v-3.4h30v3.4h-30z m10-20c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.8 1.6-1.8 1.6 0.8 1.6 1.8-0.7 1.6-1.6 1.6z m0 6.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.6 1.6-1.6 1.6 0.7 1.6 1.6-0.7 1.6-1.6 1.6z m-6.6 7.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z' })
        )
    );
};

exports.default = MdBlurLinear;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/blur-linear.js
// module id = 2649
// module chunks = 0